import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as EmptyIcon } from 'src/assets/images/catalog/empty-item.svg';
import { ScreenSwapRoute } from 'src/components/shared/routes/ScreenSwapRoute';
import { FortuneItem } from 'src/models/fortune/FortuneItem';
import { FortuneExchangeableItemDetail } from './detail/FortuneExchangeableItemDetail';
import { FortuneExchangeableItemListItem } from './FortuneExchangeableItemListItem';

interface FortuneExchangeContentProps {
  items: FortuneItem[];
}

export const FortuneExchangeContent: React.FC<FortuneExchangeContentProps> = ({ items }) => {
  const isEmpty = items.length === 0;

  return (
    <>
      <div
        className={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 100%;
          overflow: auto;
          color: #4d3906;

          .list {
            list-style-type: none;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            max-width: 480px;
            padding: 16px 12px 20px;
          }
        `}
      >
        {(() => {
          if (isEmpty) {
            return <FortuneExchangeableItemEmpty />;
          }

          return (
            <ul className="list">
              {items.map((item, i) => (
                <FortuneExchangeableItemListItem key={i} item={item} />
              ))}
            </ul>
          );
        })()}
      </div>

      <ScreenSwapRoute path="/players/fortune/exchange/detail/:id">
        <FortuneExchangeableItemDetail />
      </ScreenSwapRoute>
    </>
  );
};

const FortuneExchangeableItemEmpty: React.FC = () => {
  const { t } = useTranslation('fortune');
  return (
    <div
      className={css`
        margin: 16px 0;
        padding: 16px 24px;
      `}
    >
      <div
        className={css`
          display: flex;
          justify-content: center;
          align-items: center;
          border-top: 2px dashed #dcd8bf;
          border-bottom: 2px dashed #dcd8bf;
          padding: 16px;
          margin: 0 auto;
          h2 {
            font-size: 16px;
            margin: 0 0 0 16px;
            color: #4d3906;
          }
        `}
      >
        <EmptyIcon style={{ flex: '0 0 auto' }} />
        <h2>{t('empty_no_exchangeable_item')}</h2>
      </div>
    </div>
  );
};
